import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { IStoreState } from "../Store";
import { IAuth, IRemoteData } from "../../interface/IShareInfo";

interface IPrivateRouteProps {
  path: string;
  location?: any;
  exact: boolean;
  component: React.ComponentType;
  authData: IRemoteData<IAuth>;
}

const mapStateToProps = (state: IStoreState) => {
  return {
    authData: state.authData
  };
};

const PrivateRouteComponent = (props: IPrivateRouteProps) => {
  const { authData, ...restPara } = props;

  if (!authData.data.token) {
    const { search, pathname } = restPara.location;
    const redirectUrl = `?redirectUrl=${pathname}`;

    let newSearch = "";

    if (search) {
      newSearch = `${redirectUrl}&${search.slice(1)}`;
    } else {
      newSearch = redirectUrl;
    }

    return <Redirect to={`/login${newSearch}`} />;
  }
  return <Route {...restPara} />;
};

const PrivateRoute = connect(mapStateToProps)(PrivateRouteComponent);

export { PrivateRoute };
